import React, { useState } from "react";
import "./Register.css";
import { Link, useNavigate } from "react-router-dom";
import { useRegisterMutation } from "../../Redux/Api/AuthApi";
import { useDispatch } from "react-redux";
import { credential } from "../../Redux/Slice/AuthSlice";
import NavBar from "../../Component/NavBar/NavBar";


const Register = () => {
const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    mobile: "",
  });

  const [errors, setErrors] = useState({});
  const [terms, setTerms] = useState(false);
  const [serverError, setServerError] = useState("");

  const [register, { isLoading }] = useRegisterMutation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear field error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  // Handle Terms Checkbox
  const handleTerms = (e) => {
    setTerms(e.target.checked);
    if (e.target.checked && errors.terms) {
      setErrors((prev) => ({ ...prev, terms: "" }));
    }
  };

  // Validation Function
  const validateForm = () => {
    const newErrors = {};

    // Name validation
    if (!formData.name.trim()) newErrors.name = "Full name is required";

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    // Password validation
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    // Confirm Password
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password";
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    // Mobile validation (Rwanda format example)
    const mobileRegex = /^\+250[7][0-9]{8}$/;
    if (!formData.mobile) {
      newErrors.mobile = "Mobile number is required";
    } else if (!mobileRegex.test(formData.mobile)) {
      newErrors.mobile = "Please enter a valid Rwandan number (e.g. +250788123456)";
    }

    // Terms validation
    if (!terms) {
      newErrors.terms = "You must agree to the terms and conditions";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle Form Submit
  const handleRegister = async (e) => {
    e.preventDefault();
    setServerError("");

    if (!validateForm()) return;

    try {
      const response = await register({
        name: formData.name.trim(),
        email: formData.email.toLowerCase().trim(),
        password: formData.password,
        mobile: formData.mobile.trim(),
      }).unwrap();

      if (response?.data) {
        const { token, info } = response.data;
        dispatch(credential(JSON.stringify({ token, info })));
        return navigate('/portal/booking/classes/childQuestion');
      }
    } catch (error) {
      console.error(error);
      const errorMsg = error?.data?.message || error?.data?.error || "Registration failed. Please try again.";
      setServerError(errorMsg);
    }
  };

  return (
    <div className="register">
      <div className='about-kiga-navbar'>
       <NavBar/>
     </div>
      <div className="register-section">
        <div className="register-terms-condition">
          <div className="register-terms-background">
            <div className="register-title">
              <p>terms and condition</p>
            </div>

            <div className="terms-condition-title">
              <h3>Price And Payment</h3>
              <div className="terms-condition-list">
                <ul>
                  <li>with a month registration each class is 8,000 Rwf</li>
                  <li>
                    with registration for the term each class is 6,000 Rwf
                  </li>
                  <li>
                    A discount of 5% is applied for children attending more than
                    one class per week. this equally applicable for siblings.
                    for siblings attending more than one class per week it is
                    still 5% discount
                  </li>
                  <li>
                    if space permits,children can attend single classes for a
                    drop-in price of 10,000 Rwf / class.
                  </li>
                  <li>
                    the child must be registered and the fees paid before the
                    class starts
                  </li>
                  <li>
                    <b>Payment Can Be Made:</b>
                    <p>
                      by bank transfer to bank account number in equity bank
                      under the account names of kigali international gymnastics
                      academy(K.I.G.A) ltd. please provide proof of payment to
                      our email or when attending a session to momopay account
                      in cash before a session starts
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="terms-condition-title">
              <h3>Register and attendance</h3>
              <div className="terms-condition-list">
                <ul>
                  <li>
                    a register for each class is maintained by the teacher and
                    records student attendance for the purpose of health,safety
                    and security.
                  </li>
                  <li>the max number is 20 children per class</li>
                  <li>
                    all students must be registered for the classes they attend.
                    unregister children will not be allowed to participate in
                    the class. drop-in students may register right before start
                    of class
                  </li>
                  <li>
                    if a class is not attended by the student, it cannot be
                    refunded
                  </li>
                </ul>
              </div>
            </div>
            <div className="terms-condition-title">
              <h3>Liability</h3>
              <div className="terms-condition-list">
                <ul>
                  <li>
                    K.I.G.A does not accept any liability for any loss or damage
                    to property left on the premises
                  </li>
                  <li>
                    coaches are dedicated to ensuring the safety and well being
                    of the children under their supervision,tireless
                    implementing safety protocols and guidelines to any
                    potential risks. however,despite their best efforts,they
                    cannot be held liable the unfortunate event of an injury
                  </li>
                </ul>
              </div>
            </div>
            <div className="terms-condition-title">
              <h3>uniform & punctuality</h3>
              <div className="terms-condition-list">
                <ul>
                  <li>
                    students are required to attend class wearing comfortable
                    and appropriate clothes and to bring a bottle of water (no
                    glass).
                  </li>
                  <li>
                    the student shall arrive at least 5 minutes in advance, so
                    that the student has time to charge{" "}
                  </li>
                  <li>the lesson will start on time</li>
                  <li>
                    parents or assigned caretakers must be there on time at the
                    end of the class,in order to pick up their children K.I.G.A
                    is not responsible for children after the end of the class
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

{/* Registration Form */}
        <div className="register-form">
          <div className="register-form-section">
            <form id="form" onSubmit={handleRegister}>
              <div className="reg-form-input">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Full Name*"
                />
                {errors.name && <p className="error-text">{errors.name}</p>}
              </div>

              <div className="reg-form-input">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address*"
                />
                {errors.email && <p className="error-text">{errors.email}</p>}
              </div>

              <div className="reg-form-input">
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Password*"
                />
                {errors.password && <p className="error-text">{errors.password}</p>}
              </div>

              <div className="reg-form-input">
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder="Confirm Password*"
                />
                {errors.confirmPassword && <p className="error-text">{errors.confirmPassword}</p>}
              </div>

              <div className="reg-form-input">
                <label htmlFor="mobile">Mobile Number</label>
                <input
                  type="tel"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="e.g. +250788123456"
                />
                {errors.mobile && <p className="error-text">{errors.mobile}</p>}
              </div>

              <div className="checkbox">
                <input
                  type="checkbox"
                  name="agree"
                  checked={terms}
                  onChange={handleTerms}
                />
                <label htmlFor="condition">
                  I agree to the terms and conditions of registration with Kiga.
                </label>
              </div>
              {errors.terms && <p className="error-text">{errors.terms}</p>}

              {/* Server Error */}
              {serverError && (
                <div className="error-msg">
                  <p>{serverError}</p>
                </div>
              )}

              <div className="reg-button">
                <button type="submit" disabled={isLoading}>
                  {isLoading ? "Processing..." : "Next"}
                </button>
              </div>

              <div className="register-inform">
                <p>
                  Already have an account? <Link to="/login">Login here</Link>.
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
